<template>
  <UiTable
    :storage-id="storageId"
    class="log-table"
    :source-columns="columns"
    :rows="[...row]"
    :is-loading="isLoading"
    :pagination="{ show: false }"
    :total="1"
  />
</template>

<script>
import getValue from '@/components/table/helpers/getValue'
import UiTable from '@/components/table/UiTable.vue'

import DateTime from '@/components/DateTime'

import { mapGetters } from 'vuex'

export default {
  components: { UiTable },
  data() {
    return {
      storageId: 'log-table',
      isLoading: true,
      columns: [
        {
          field: 'time',
          title: 'Дата',
          align: 'left',
          key: 'date',
          renderBodyCell: ({ row }, h) => <DateTime date={row.time} />,
        },
        {
          field: 'message',
          title: 'Сообщение',
          align: 'left',
          key: 'message',
          renderBodyCell: ({ row }) => getValue(row, 'message'),
        },
        {
          field: 'url',
          title: 'Url',
          align: 'left',
          key: 'url',
          renderBodyCell: ({ row }) => getValue(row, 'url'),
        },
        {
          field: 'application',
          title: 'App',
          align: 'left',
          key: 'app',
          renderBodyCell: ({ row }) => {
            if (!(row.application && row.application.domain)) return '—'

            return `${row.application.domain} (${row.application.id})`
          },
        },
        {
          field: 'userId',
          title: 'User',
          align: 'left',
          key: 'user',
          renderBodyCell: ({ row }) => getValue(row, 'userId'),
        },
        {
          field: 'guestId',
          title: 'Guest',
          align: 'left',
          key: 'guest',
          renderBodyCell: ({ row }) => getValue(row, 'guestId'),
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      currentLogRow: 'logs/currentLogRow',
    }),
    row() {
      return this.currentLogRow ?? []
    },
  },
  mounted() {
    this.isLoading = false
  },
}
</script>
